import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Dialog } from '@angular/cdk/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { QRCodeModule } from 'angularx-qrcode';
import { ConfirmDialogComponent, ConfirmDialogData, ConfirmDialogResult } from '@libs/ui-lib';
import { TokenService } from '@libs/shared-services';
import { EXTERNAL_LINKS } from '@libs/utils';

const QR_CODE_SIZE = 188;
const QR_CODE_LOGO_SIZE = 30;

@Component({
  selector: 'lib-ascend-eaglesoft-blocker',
  imports: [TranslateModule, SvgIconComponent, QRCodeModule],
  templateUrl: './ascend-eaglesoft-blocker.component.html',
  styleUrl: './ascend-eaglesoft-blocker.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AscendEaglesoftBlockerComponent {
  private readonly dialog = inject(Dialog);
  private readonly tokenService = inject(TokenService);

  protected readonly appStoreUrl = EXTERNAL_LINKS.FFD_NOTES_IOS_APP;
  protected readonly qrCodeSize = QR_CODE_SIZE;
  protected readonly qrCodeLogoSize = QR_CODE_LOGO_SIZE;

  protected onDoneClick(): void {
    const data: ConfirmDialogData = {
      title: 'ascend_eaglesoft_blocker_logout_confirm_title',
      description: '',
      cancelLabel: 'ascend_eaglesoft_blocker_logout_confirm_cancel',
      confirmLabel: 'ascend_eaglesoft_blocker_logout_confirm_confirm',
    };

    this.dialog
      .open<ConfirmDialogResult>(ConfirmDialogComponent, {
        data,
        backdropClass: ['backdrop-blur-overlay', 'bg-overlay-light'],
        panelClass: ['w-[480px]'],
      })
      .closed.subscribe((result) => {
        if (result?.confirm) {
          this.tokenService.logout();
        }
      });
  }
}
